export default [
  {
    title: '儀錶板',
    route: 'home',
    action: 'read',
    resource: 'Dashboard',
    icon: 'HomeIcon',
  },
  {
    title: '數據查詢',
    icon: 'DatabaseIcon',
    children: [
      {
        title: '歷史資料查詢',
        route: 'history-data',
        action: 'read',
        resource: 'Data',
      },
      {
        title: '歷史趨勢圖',
        route: 'history-trend',
        action: 'read',
        resource: 'Data',
      },
      {
        title: '警報記錄查詢',
        route: 'alarm-query',
        action: 'read',
        resource: 'Data',
      },
      {
        title: '完整率異常查詢',
        route: 'effective-rate-report',
        action: 'read',
        resource: 'Data',
      },
    ],
  },
  {
    title: '報表查詢',
    icon: 'BookOpenIcon',
    children: [
      {
        title: '監測報表',
        route: 'report',
        action: 'read',
        resource: 'Report',
      },
      {
        title: '月份時報表',
        route: 'monthly-hour-report',
        action: 'read',
        resource: 'Report',
      },
      {
        title: '離群分析報表',
        route: 'outstanding-report',
        action: 'read',
        resource: 'Report',
      },
    ],
  },
  //辨識結果
  {
    title: '辨識結果',
    icon: 'CameraIcon',
    children: [
      {
        title: '辨識結果查詢',
        route: 'image-query',
        action: 'read',
        resource: 'ImageRecognizerResult',
      },
    ],
  },
  {
    title: '影像監控',
    icon: 'CameraIcon',
    children: [
      {
        title: '自動辨識設定',
        route: 'camera-management',
        action: 'read',
        resource: 'Image',
      },
      {
        title: '手動上傳辨識',
        route: 'upload-image',
        action: 'read',
        resource: 'Image',
      },
      {
        title: '辨識結果查詢',
        route: 'image-query',
        action: 'read',
        resource: 'Image',
      },
      {
        title: '影像辨識模式',
        route: 'image-recognition-test',
        action: 'read',
        resource: 'Image',
      },
      {
        title: '辨識率驗證',
        route: 'image-recognition-display',
        action: 'read',
        resource: 'Image',
      },
    ],
  },
  {
    title: '系統管理',
    icon: 'CheckCircleIcon',
    children: [
      {
        title: '儀器管理',
        route: 'instrument-management',
        action: 'read',
        resource: 'System',
      },
      {
        title: '儀器狀態查詢',
        route: 'instrument-status',
        action: 'read',
        resource: 'System',
      },
      {
        title: '測點管理',
        route: 'monitor-config',
        action: 'read',
        resource: 'System',
      },
      {
        title: '感測器管理',
        route: 'sensor-management',
        action: 'read',
        resource: 'System',
      },
      {
        title: '測項管理',
        route: 'monitor-type-config',
        action: 'read',
        resource: 'System',
      },
      {
        title: '人工資料註記',
        route: 'manual-audit',
        action: 'read',
        resource: 'System',
      },
      {
        title: '人工註記查詢',
        route: 'audit-log-query',
        action: 'read',
        resource: 'System',
      },
      {
        title: '使用者管理',
        route: 'user-management',
        action: 'read',
        resource: 'System',
      },
      {
        title: '群組管理',
        route: 'group-management',
        action: 'read',
        resource: 'System',
      },
      {
        title: '資料管理',
        route: 'data-management',
        action: 'read',
        resource: 'System',
      },
      {
        title: '上傳資料',
        route: 'upload-data',
        action: 'read',
        resource: 'System',
      },
    ],
  },
];
